let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("73smL")).then(() => parcelRequire('585rS'));